import { Grid } from '@mui/material';
import { RoutalLoader } from '@nx-smartmonkey/ui';
import { Navigate, useParams } from 'react-router-dom';

import * as routing from '../../../constants/Routing';
import useValidateUser from '../../../hooks/user/useValidateUser';

export const UserValidation = () => {
  const { token } = useParams();

  const { isLoading } = useValidateUser({ token: token ?? `` });

  if (token && isLoading) {
    return (
      <Grid
        container
        justifyContent="center"
        style={{ height: `100%`, backgroundColor: `#e9e9e9` }}
        alignItems="center"
      >
        <Grid container justifyContent="center" style={{ width: `200px`, height: `200px` }}>
          <RoutalLoader />
        </Grid>
      </Grid>
    );
  }

  return <Navigate to={routing.AUTH.LOGIN} />;
};
